import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/creator/community-ios-mobile.webp")